module.exports = __webpack_public_path__ + "static/media/ecodesign.d45424e6.png";